import { render, staticRenderFns } from "./OfisProUyarilar.vue?vue&type=template&id=35f7abd6&scoped=true"
import script from "./OfisProUyarilar.vue?vue&type=script&lang=ts"
export * from "./OfisProUyarilar.vue?vue&type=script&lang=ts"
import style0 from "./OfisProUyarilar.vue?vue&type=style&index=0&id=35f7abd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f7abd6",
  null
  
)

export default component.exports